import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { capabilities, products } from '../data/products';

const Portfolio = () => (
    <section id="portfolio" aria-labelledby="products-title" className="scroll-mt-24 mx-auto max-w-screen-2xl px-5 sm:px-8 lg:px-12 py-16">
        <h2 id="products-title" className="text-center text-3xl font-bold text-blue-900">Explore our products</h2>
        <p className="mx-auto mt-4 max-w-3xl text-center text-lg text-gray-600">Different applications, connected by reusable AI capabilities and workflows built around their users.</p>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {products.map(product => (
                <article id={`product-${product.id}`} key={product.id} className="scroll-mt-24 flex flex-col rounded-xl border border-blue-100 bg-white p-6 shadow-md">
                    <h3 className="text-2xl font-bold text-blue-900">{product.name}</h3>
                    <p className="mt-2 font-semibold text-blue-900">{product.subtitle}</p>
                    <p className="mt-5 leading-relaxed text-gray-600">{product.description}</p>
                    {product.note && <p className="mt-4 text-sm leading-relaxed text-blue-900">{product.note}</p>}
                    <ul aria-label="Core capabilities" className="mt-5 mb-6 flex flex-wrap gap-2">
                        {product.capabilities.map(id => <li key={id} className="rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-900">{capabilities.find(c => c.id === id).title}</li>)}
                    </ul>
                    {product.href.startsWith('/') ? (
                        <HashLink to={product.href} className="mt-auto rounded-xl bg-blue-900 px-4 py-3 text-center font-semibold text-white hover:bg-blue-800">{product.cta} <span aria-hidden="true">→</span></HashLink>
                    ) : (
                        <a href={product.href} className="mt-auto rounded-xl bg-blue-900 px-4 py-3 text-center font-semibold text-white hover:bg-blue-800">{product.cta} <span aria-hidden="true">→</span></a>
                    )}
                </article>
            ))}
        </div>
    </section>
);
export default Portfolio;
